import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Star } from 'lucide-react';
import { APP_CONFIG, ROUTES } from '../../config/app.config';
import SocialIcon, { SocialNetwork } from '../common/SocialIcon';
import catesWhiteLogo from '../../assets/cates_logo_mark_white.png';

const BRAND_BLUE = '#0072c6';
const BRAND_LIGHT = '#1493e6';
const BRAND_SILVER = '#e6edf5';
const BRAND_DARK = '#050608';

const SocialLinks: { network: SocialNetwork; href: string; title: string }[] = [
  { network: 'facebook', href: APP_CONFIG.socialLinks.facebook, title: 'Facebook' },
  { network: 'instagram', href: APP_CONFIG.socialLinks.instagram, title: 'Instagram' },
  { network: 'youtube', href: APP_CONFIG.socialLinks.youtube, title: 'YouTube' },
  { network: 'twitter', href: APP_CONFIG.socialLinks.twitter, title: 'X / Twitter' },
  { network: 'linkedin', href: APP_CONFIG.socialLinks.linkedin, title: 'LinkedIn' },
];

const PublicFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: BRAND_DARK, color: BRAND_LIGHT }}>
      {/* CTA Band */}
      <div style={{
        background: `linear-gradient(135deg, ${BRAND_LIGHT}, ${BRAND_BLUE})`,
        padding: '3.5rem 1.5rem', textAlign: 'center',
      }}>
        <h2 style={{ color: 'white', fontSize: '1.75rem', fontWeight: 900, marginBottom: '0.75rem', textTransform: 'uppercase', letterSpacing: '-0.5px' }}>
          Ready for a Free Roof Inspection?
        </h2>
        <p style={{ color: '#ffffff', marginBottom: '1.5rem', maxWidth: '480px', margin: '0 auto 1.5rem' }}>
          No pressure. No obligation. Just an honest assessment from an experienced roofing professional.
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to={ROUTES.QUOTE} style={{
            background: 'white', color: BRAND_DARK, padding: '0.75rem 2rem',
            borderRadius: '100px', fontWeight: 800, textDecoration: 'none',
            fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '0.04em',
            fontFamily: "'Public Sans', Helvetica, Arial, Lucida, sans-serif",
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.transform = 'translateY(-2px)'; (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 24px rgba(0,0,0,0.2)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.transform = ''; (e.currentTarget as HTMLElement).style.boxShadow = ''; }}
          >
            SCHEDULE FREE INSPECTION
          </Link>
          <a href={`tel:${APP_CONFIG.phoneRaw}`} style={{
            border: '2px solid rgba(255,255,255,0.95)', color: 'white',
            padding: '0.75rem 2rem', borderRadius: '100px', fontWeight: 700,
            textDecoration: 'none', fontSize: '0.9rem', textTransform: 'uppercase',
            letterSpacing: '0.04em', fontFamily: "'Public Sans', Helvetica, Arial, Lucida, sans-serif",
          }}>
            {APP_CONFIG.phone}
          </a>
        </div>
      </div>

      {/* Main Footer */}
      <div className="container-xl" style={{ padding: '4rem 1.5rem 2rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '3rem', marginBottom: '3rem' }}>
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '176px' }}>
              <img
                src={catesWhiteLogo}
                alt="Cates Roofing & Contracting"
                style={{ height: '54px', width: '176px', objectFit: 'contain', display: 'block' }}
                onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
              />
              <span className="nav-strapline" style={{
                display: 'block', marginTop: '0.25rem',
                color: 'rgba(255,255,255,0.82)', fontSize: '0.5rem',
                fontWeight: 300, letterSpacing: '0.06em', textTransform: 'uppercase',
                whiteSpace: 'nowrap', lineHeight: 1, textAlign: 'center',
              }}>
                – Family Legacy {APP_CONFIG.familyBusinessLegacySince} –
              </span>
            </div>
            {/* <div style={{ marginBottom: '1.25rem' }}>
              <img
                src={catesWhiteLogo}
                alt="Cates Roofing & Contracting"
                style={{ height: '54px', width: '176px', objectFit: 'contain', objectPosition: 'left', display: 'block' }}
                onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
              />
              <span style={{
                display: 'block', marginTop: '0.5rem', color: 'rgba(230,237,245,0.75)',
                fontSize: '0.62rem', fontWeight: 700, letterSpacing: '0.1em',
                textTransform: 'uppercase', textAlign: 'left',
              }}>
                – Family Legacy {APP_CONFIG.familyBusinessLegacySince} –
              </span>
            </div> */}
            <p style={{ fontSize: '0.875rem', lineHeight: 1.7, marginBottom: '1.25rem', maxWidth: '260px' }}>
              {APP_CONFIG.description}
            </p>
            <div style={{ display: 'flex', gap: '0.625rem' }}>
              {SocialLinks.map(s => (
                <a key={s.href} href={s.href} title={s.title} aria-label={s.title} target="_blank" rel="noopener noreferrer" style={{
                  width: '2.25rem', height: '2.25rem', borderRadius: '0.5rem',
                  border: `1px solid rgba(0,114,198,0.45)`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: BRAND_LIGHT, transition: 'all 0.2s',
                  textDecoration: 'none',
                }}
                  onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = BRAND_LIGHT; (e.currentTarget as HTMLElement).style.color = BRAND_LIGHT; (e.currentTarget as HTMLElement).style.background = 'rgba(0,114,198,0.65)'; }}
                  onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(0,114,198,0.75)'; (e.currentTarget as HTMLElement).style.color = BRAND_LIGHT; (e.currentTarget as HTMLElement).style.background = ''; }}>
                  <SocialIcon network={s.network} size={17} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 style={{ color: 'white', fontWeight: 800, fontSize: '0.85rem', marginBottom: '1.25rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Services</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
              {[
                ['Roof Replacement', '/services/roof-replacement'],
                ['Insurance Claim Assistance', '/services/insurance-claims'],
                ['Roof Repair', '/services/roof-repair'],
                ['Roof Inspection', '/services/roof-inspection'],
                ['Commercial Roofing', '/services/commercial-roofing'],
                ['Emergency Service', '/services/emergency-roofing'],
                ['Roof Cleaning', '/services/roof-cleaning'],
                ['Gutter Cleaning', '/services/gutter-cleaning'],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} style={{ fontSize: '0.875rem', color: BRAND_LIGHT, textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => (e.currentTarget.style.color = BRAND_BLUE)}
                    onMouseLeave={e => (e.currentTarget.style.color = BRAND_LIGHT)}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 style={{ color: 'white', fontWeight: 800, fontSize: '0.85rem', marginBottom: '1.25rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Company</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '0.625rem' }}>
              {[
                ['About Us', ROUTES.ABOUT],
                ['Gallery', ROUTES.GALLERY],
                ['Blog', ROUTES.BLOG],
                ['Testimonials', ROUTES.TESTIMONIALS],
                ['Service Areas', ROUTES.SERVICE_AREAS],
                ['Financing', ROUTES.FINANCING],
                ['Careers', ROUTES.CAREERS],
                ['FAQ', ROUTES.FAQ],
              ].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} style={{ fontSize: '0.875rem', color: BRAND_LIGHT, textDecoration: 'none', transition: 'color 0.2s' }}
                    onMouseEnter={e => (e.currentTarget.style.color = BRAND_BLUE)}
                    onMouseLeave={e => (e.currentTarget.style.color = BRAND_LIGHT)}>
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 style={{ color: 'white', fontWeight: 800, fontSize: '0.85rem', marginBottom: '1.25rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Contact</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <a href={`tel:${APP_CONFIG.phoneRaw}`} style={{ display: 'flex', gap: '0.75rem', color: BRAND_LIGHT, textDecoration: 'none', fontSize: '0.875rem' }}>
                <Phone size={16} style={{ color: BRAND_LIGHT, flexShrink: 0, marginTop: '2px' }} />
                <span>{APP_CONFIG.phone}</span>
              </a>
              <a href={`mailto:${APP_CONFIG.email}`} style={{ display: 'flex', gap: '0.75rem', color: BRAND_LIGHT, textDecoration: 'none', fontSize: '0.875rem' }}>
                <Mail size={16} style={{ color: BRAND_LIGHT, flexShrink: 0, marginTop: '2px' }} />
                <span>{APP_CONFIG.email}</span>
              </a>
              <div style={{ display: 'flex', gap: '0.75rem', fontSize: '0.875rem' }}>
                <MapPin size={16} style={{ color: BRAND_LIGHT, flexShrink: 0, marginTop: '2px' }} />
                <span>{APP_CONFIG.address}<br />{APP_CONFIG.city}, {APP_CONFIG.state} {APP_CONFIG.zip}</span>
              </div>
            </div>
            <div style={{ marginTop: '1.5rem' }}>
              <h4 style={{ color: 'white', fontWeight: 700, fontSize: '0.8rem', marginBottom: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Business Hours</h4>
              <div style={{ fontSize: '0.8rem', display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
                <span>Mon–Fri: {APP_CONFIG.businessHours.weekdays}</span>
                <span>Saturday: {APP_CONFIG.businessHours.saturday}</span>
                <span style={{ color: BRAND_BLUE }}>Sunday: {APP_CONFIG.businessHours.sunday}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div style={{ borderTop: `1px solid rgba(0,114,198,0.35)`, paddingTop: '2rem', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.25rem', alignItems: 'center', justifyContent: 'center' }}>
            {[
              { icon: '⭐', label: '5.0 Google Rating', sub: `${APP_CONFIG.reputation.reviewCount} Reviews` },
              { icon: '🏆', label: 'Owens Corning Certified', sub: 'Preferred Contractor' },
              { icon: '🛡️', label: '10-Year Warranty', sub: 'On All Work' },
              { icon: '💳', label: '0% Financing', sub: '18 Months' },
              { icon: '🚨', label: '24/7 Emergency', sub: '2-Hour Response' },
            ].map(badge => (
              <div key={badge.label} style={{
                display: 'flex', alignItems: 'center', gap: '0.5rem',
                background: BRAND_BLUE, border: `1px solid rgba(20,147,230,0.85)`,
                borderRadius: '0.75rem', padding: '0.625rem 1rem',
                transition: 'border-color 0.2s ease',
              }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = BRAND_LIGHT; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = 'rgba(20,147,230,0.6)'; }}
              >
                <span style={{ fontSize: '1.25rem' }}>{badge.icon}</span>
                <div>
                  <div style={{ color: 'white', fontSize: '0.8rem', fontWeight: 700 }}>{badge.label}</div>
                  <div style={{ fontSize: '0.7rem' }}>{badge.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Star Rating */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.25rem', marginBottom: '0.25rem' }}>
            {[1, 2, 3, 4, 5].map(i => <Star key={i} size={18} fill={BRAND_LIGHT} stroke="none" />)}
          </div>
          <p style={{ fontSize: '0.8rem' }}>{APP_CONFIG.reputation.rating} average rating from {APP_CONFIG.reputation.reviewCount} verified {APP_CONFIG.reputation.source} reviews</p>
        </div>

        {/* Bottom Bar */}
        <div style={{ borderTop: `1px solid rgba(0,114,198,0.35)`, paddingTop: '1.5rem', display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'space-between', alignItems: 'center', fontSize: '0.8rem' }}>
          <span>© {year} {APP_CONFIG.name}. All rights reserved.</span>
          <div style={{ display: 'flex', gap: '1.5rem' }}>
            {APP_CONFIG.licenses.map(l => (
              <span key={l} style={{ color: BRAND_SILVER }}>{l}</span>
            ))}
          </div>
          <div style={{ display: 'flex', gap: '1rem' }}>
            <Link to={ROUTES.PRIVACY} style={{ color: BRAND_SILVER, textDecoration: 'none' }}
              onMouseEnter={e => (e.currentTarget.style.color = BRAND_LIGHT)}
              onMouseLeave={e => (e.currentTarget.style.color = BRAND_SILVER)}>Privacy</Link>
            <Link to={ROUTES.TERMS} style={{ color: BRAND_SILVER, textDecoration: 'none' }}
              onMouseEnter={e => (e.currentTarget.style.color = BRAND_LIGHT)}
              onMouseLeave={e => (e.currentTarget.style.color = BRAND_SILVER)}>Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
